export default __webpack_public_path__ + "static/media/social-media-big.c425a61e.gif";